import { SVGProps } from '../types';

export const FilledFolderIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <mask id="path-1-inside-1_82_86724" fill="#fff">
      <path
        fillRule="evenodd"
        d="M3.333 1.25A3.333 3.333 0 0 0 0 4.583v8.834c0 1.867 0 2.8.363 3.513.32.627.83 1.137 1.457 1.457.713.363 1.646.363 3.513.363h9.334c1.867 0 2.8 0 3.513-.363a3.33 3.33 0 0 0 1.457-1.457c.363-.713.363-1.646.363-3.513V8.25c0-1.867 0-2.8-.363-3.513A3.33 3.33 0 0 0 18.18 3.28c-.713-.363-1.646-.363-3.513-.363h-3.595c-1.573 0-3.07-1.667-4.642-1.667z"
        clipRule="evenodd"
      />
    </mask>
    <path
      fill="#667085"
      fillRule="evenodd"
      d="M3.333 1.25A3.333 3.333 0 0 0 0 4.583v8.834c0 1.867 0 2.8.363 3.513.32.627.83 1.137 1.457 1.457.713.363 1.646.363 3.513.363h9.334c1.867 0 2.8 0 3.513-.363a3.33 3.33 0 0 0 1.457-1.457c.363-.713.363-1.646.363-3.513V8.25c0-1.867 0-2.8-.363-3.513A3.33 3.33 0 0 0 18.18 3.28c-.713-.363-1.646-.363-3.513-.363h-3.595c-1.573 0-3.07-1.667-4.642-1.667z"
      clipRule="evenodd"
    />
    <path
      fill="url(#paint0_linear_82_86724)"
      d="m.363 16.93-.37.19zm1.457 1.457-.19.37zm16.36 0 .19.37zm1.457-1.457.37.19zm0-12.193.37-.19zM18.18 3.28l.19-.371zM.417 4.583a2.917 2.917 0 0 1 2.916-2.916V.833a3.75 3.75 0 0 0-3.75 3.75zm0 3.667V4.583h-.834V8.25zm0 .064V8.25h-.834v.064zm0 5.103V8.314h-.834v5.103zm.318 3.324c-.147-.288-.231-.639-.274-1.169-.044-.535-.044-1.215-.044-2.155h-.834c0 .926 0 1.646.047 2.223.048.581.145 1.054.362 1.48zm1.274 1.274a2.9 2.9 0 0 1-1.274-1.274l-.743.378a3.75 3.75 0 0 0 1.639 1.639zm3.324.318c-.94 0-1.62 0-2.155-.044-.53-.043-.88-.127-1.169-.274l-.378.743c.425.216.897.314 1.48.362.576.047 1.296.047 2.222.047zm9.334 0H5.333v.834h9.334zm3.324-.318c-.288.147-.639.231-1.169.274-.535.044-1.215.044-2.155.044v.834c.926 0 1.646 0 2.223-.047.581-.048 1.054-.146 1.48-.362zm1.274-1.274c-.28.549-.725.995-1.274 1.274l.378.743a3.75 3.75 0 0 0 1.639-1.639zm.318-3.324c0 .94 0 1.62-.044 2.155-.043.53-.127.88-.274 1.169l.743.378c.216-.425.314-.898.362-1.48.047-.576.047-1.296.047-2.222zm0-5.167v5.167h.834V8.25zm-.318-3.324c.147.288.231.639.274 1.169.044.535.044 1.215.044 2.155h.834c0-.927 0-1.647-.047-2.223-.048-.582-.146-1.054-.362-1.48zM17.991 3.65c.549.28.995.726 1.274 1.275l.743-.378a3.75 3.75 0 0 0-1.639-1.64zm-3.324-.318c.94 0 1.62 0 2.155.044.53.044.88.127 1.169.274l.378-.742c-.425-.217-.898-.315-1.48-.362-.576-.047-1.296-.047-2.222-.047zm-3.595 0h3.595V2.5h-3.595zM3.333 1.667H6.43V.833H3.333zm7.739.833c-.66 0-1.33-.352-2.123-.783-.742-.403-1.607-.884-2.52-.884v.834c.66 0 1.33.352 2.123.783.742.402 1.607.883 2.52.883z"
      mask="url(#path-1-inside-1_82_86724)"
    />
    <rect
      width="19.583"
      height="12.917"
      x="0.208"
      y="5.625"
      fill="#98A2B3"
      stroke="url(#paint1_linear_82_86724)"
      strokeWidth="0.417"
      rx="3.125"
    />
    <rect
      width="20"
      height="13.333"
      y="5.417"
      fill="url(#paint2_linear_82_86724)"
      opacity="0.2"
      rx="3.333"
    />
    <defs>
      <linearGradient
        id="paint0_linear_82_86724"
        x1="10"
        x2="10"
        y1="1.25"
        y2="18.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.12"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_82_86724"
        x1="10"
        x2="10"
        y1="5.417"
        y2="18.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.12"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="paint2_linear_82_86724"
        x1="0"
        x2="13.754"
        y1="5.417"
        y2="18.301"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
    </defs>
  </svg>
);
